function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.66669 6.66667C6.66669 6.29848 6.96516 6 7.33335 6H7.86669C8.5844 6 9.06669 6.61713 9.06669 7.25V10.1667C9.06669 10.5003 9.30075 10.6667 9.46669 10.6667H10C10.3682 10.6667 10.6667 10.9651 10.6667 11.3333C10.6667 11.7015 10.3682 12 10 12H9.46669C8.45442 12 7.73335 11.1217 7.73335 10.1667V7.33333H7.33335C6.96516 7.33333 6.66669 7.03486 6.66669 6.66667Z",
  fill: "black",
  fillOpacity: 0.85
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.33331 8C1.33331 4.3181 4.31808 1.33333 7.99998 1.33333C11.6819 1.33333 14.6666 4.3181 14.6666 8C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8ZM7.99998 2.54545C4.98752 2.54545 2.54543 4.98753 2.54543 8C2.54543 11.0125 4.98752 13.4545 7.99998 13.4545C11.0124 13.4545 13.4545 11.0125 13.4545 8C13.4545 4.98753 11.0124 2.54545 7.99998 2.54545Z",
  fill: "black",
  fillOpacity: 0.85
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.66665 4.66666C8.66665 5.03485 8.36817 5.33333 7.99998 5.33333C7.63179 5.33333 7.33331 5.03485 7.33331 4.66666C7.33331 4.29847 7.63179 3.99999 7.99998 3.99999C8.36817 3.99999 8.66665 4.29847 8.66665 4.66666Z",
  fill: "black",
  fillOpacity: 0.85
});
var SvgInformation = function SvgInformation(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInformation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/information.d3dba09c.svg";
export { ForwardRef as ReactComponent };